/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Campaign
 */
export interface Campaign {
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    'status'?: string;
    /**
     * 
     * @type {CampaignSettings}
     * @memberof Campaign
     */
    'settings'?: CampaignSettings;
    /**
     * 
     * @type {string}
     * @memberof Campaign
     */
    'send_time'?: string;
}
/**
 * 
 * @export
 * @interface CampaignSettings
 */
export interface CampaignSettings {
    /**
     * 
     * @type {string}
     * @memberof CampaignSettings
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSettings
     */
    'subject_line'?: string;
    /**
     * 
     * @type {string}
     * @memberof CampaignSettings
     */
    'from_name'?: string;
}
/**
 * 
 * @export
 * @interface ContactUsDto
 */
export interface ContactUsDto {
    /**
     * 
     * @type {number}
     * @memberof ContactUsDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactUsDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsDto
     */
    'contactNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsDto
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsDto
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUsDto
     */
    'creationDate'?: string;
}
/**
 * 
 * @export
 * @interface CreateContactUsDto
 */
export interface CreateContactUsDto {
    /**
     * 
     * @type {string}
     * @memberof CreateContactUsDto
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactUsDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactUsDto
     */
    'contactNo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactUsDto
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContactUsDto
     */
    'content'?: string;
}
/**
 * 
 * @export
 * @interface CreateRequestDemoDto
 */
export interface CreateRequestDemoDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDemoDto
     */
    'contactName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDemoDto
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDemoDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDemoDto
     */
    'phoneNO': string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDemoDto
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRequestDemoDto
     */
    'vehicleCountRange'?: string;
}
/**
 * 
 * @export
 * @interface JwtResponse
 */
export interface JwtResponse {
    /**
     * 
     * @type {string}
     * @memberof JwtResponse
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof JwtResponse
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof JwtResponse
     */
    'refreshToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof JwtResponse
     */
    'tokenType'?: string;
    /**
     * 
     * @type {string}
     * @memberof JwtResponse
     */
    'expiration'?: string;
}
/**
 * 
 * @export
 * @interface LoginVM
 */
export interface LoginVM {
    /**
     * 
     * @type {string}
     * @memberof LoginVM
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginVM
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface RequestDemoDto
 */
export interface RequestDemoDto {
    /**
     * 
     * @type {number}
     * @memberof RequestDemoDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestDemoDto
     */
    'contactName': string;
    /**
     * 
     * @type {string}
     * @memberof RequestDemoDto
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof RequestDemoDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RequestDemoDto
     */
    'phoneNO': string;
    /**
     * 
     * @type {string}
     * @memberof RequestDemoDto
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestDemoDto
     */
    'vehicleCountRange'?: string;
}

/**
 * CampaignControllerApi - axios parameter creator
 * @export
 */
export const CampaignControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllMembers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns/members/delete-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMailchimpCampaigns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/campaigns/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignReport: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getCampaignReport', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/report`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replicateCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('replicateCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/replicate`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('sendCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/campaigns/{campaignId}/send`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContacts: async (campaignId: string, categoryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('uploadContacts', 'campaignId', campaignId)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('uploadContacts', 'categoryId', categoryId)
            const localVarPath = `/api/campaigns/{campaignId}/upload-contacts`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignControllerApi - functional programming interface
 * @export
 */
export const CampaignControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllMembers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllMembers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignControllerApi.deleteAllMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMailchimpCampaigns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Campaign>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMailchimpCampaigns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignControllerApi.getAllMailchimpCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCampaignReport(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCampaignReport(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignControllerApi.getCampaignReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replicateCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Campaign>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replicateCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignControllerApi.replicateCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignControllerApi.sendCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadContacts(campaignId: string, categoryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadContacts(campaignId, categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignControllerApi.uploadContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignControllerApi - factory interface
 * @export
 */
export const CampaignControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllMembers(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.deleteAllMembers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMailchimpCampaigns(options?: RawAxiosRequestConfig): AxiosPromise<Array<Campaign>> {
            return localVarFp.getAllMailchimpCampaigns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCampaignReport(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getCampaignReport(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replicateCampaign(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<Campaign> {
            return localVarFp.replicateCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCampaign(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.sendCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} campaignId 
         * @param {number} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadContacts(campaignId: string, categoryId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.uploadContacts(campaignId, categoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignControllerApi - object-oriented interface
 * @export
 * @class CampaignControllerApi
 * @extends {BaseAPI}
 */
export class CampaignControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public deleteAllMembers(options?: RawAxiosRequestConfig) {
        return CampaignControllerApiFp(this.configuration).deleteAllMembers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public getAllMailchimpCampaigns(options?: RawAxiosRequestConfig) {
        return CampaignControllerApiFp(this.configuration).getAllMailchimpCampaigns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public getCampaignReport(campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignControllerApiFp(this.configuration).getCampaignReport(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public replicateCampaign(campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignControllerApiFp(this.configuration).replicateCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public sendCampaign(campaignId: string, options?: RawAxiosRequestConfig) {
        return CampaignControllerApiFp(this.configuration).sendCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} campaignId 
     * @param {number} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CampaignControllerApi
     */
    public uploadContacts(campaignId: string, categoryId: number, options?: RawAxiosRequestConfig) {
        return CampaignControllerApiFp(this.configuration).uploadContacts(campaignId, categoryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MarketingControllerApi - axios parameter creator
 * @export
 */
export const MarketingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateContactUsDto} createContactUsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactUs: async (createContactUsDto: CreateContactUsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createContactUsDto' is not null or undefined
            assertParamExists('createContactUs', 'createContactUsDto', createContactUsDto)
            const localVarPath = `/api/marketing/contactUs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContactUsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateRequestDemoDto} createRequestDemoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDemo: async (createRequestDemoDto: CreateRequestDemoDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRequestDemoDto' is not null or undefined
            assertParamExists('requestDemo', 'createRequestDemoDto', createRequestDemoDto)
            const localVarPath = `/api/marketing/requestDemo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRequestDemoDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingControllerApi - functional programming interface
 * @export
 */
export const MarketingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateContactUsDto} createContactUsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactUs(createContactUsDto: CreateContactUsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactUsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactUs(createContactUsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingControllerApi.createContactUs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateRequestDemoDto} createRequestDemoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDemo(createRequestDemoDto: CreateRequestDemoDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequestDemoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDemo(createRequestDemoDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingControllerApi.requestDemo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarketingControllerApi - factory interface
 * @export
 */
export const MarketingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateContactUsDto} createContactUsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactUs(createContactUsDto: CreateContactUsDto, options?: RawAxiosRequestConfig): AxiosPromise<ContactUsDto> {
            return localVarFp.createContactUs(createContactUsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateRequestDemoDto} createRequestDemoDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDemo(createRequestDemoDto: CreateRequestDemoDto, options?: RawAxiosRequestConfig): AxiosPromise<RequestDemoDto> {
            return localVarFp.requestDemo(createRequestDemoDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketingControllerApi - object-oriented interface
 * @export
 * @class MarketingControllerApi
 * @extends {BaseAPI}
 */
export class MarketingControllerApi extends BaseAPI {
    /**
     * 
     * @param {CreateContactUsDto} createContactUsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingControllerApi
     */
    public createContactUs(createContactUsDto: CreateContactUsDto, options?: RawAxiosRequestConfig) {
        return MarketingControllerApiFp(this.configuration).createContactUs(createContactUsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateRequestDemoDto} createRequestDemoDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingControllerApi
     */
    public requestDemo(createRequestDemoDto: CreateRequestDemoDto, options?: RawAxiosRequestConfig) {
        return MarketingControllerApiFp(this.configuration).requestDemo(createRequestDemoDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserJwtControllerApi - axios parameter creator
 * @export
 */
export const UserJwtControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginVM} loginVM 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: async (loginVM: LoginVM, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginVM' is not null or undefined
            assertParamExists('authenticateUser', 'loginVM', loginVM)
            const localVarPath = `/api/authenticate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginVM, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserJwtControllerApi - functional programming interface
 * @export
 */
export const UserJwtControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserJwtControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginVM} loginVM 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateUser(loginVM: LoginVM, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JwtResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateUser(loginVM, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserJwtControllerApi.authenticateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserJwtControllerApi - factory interface
 * @export
 */
export const UserJwtControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserJwtControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginVM} loginVM 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser(loginVM: LoginVM, options?: RawAxiosRequestConfig): AxiosPromise<JwtResponse> {
            return localVarFp.authenticateUser(loginVM, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserJwtControllerApi - object-oriented interface
 * @export
 * @class UserJwtControllerApi
 * @extends {BaseAPI}
 */
export class UserJwtControllerApi extends BaseAPI {
    /**
     * 
     * @param {LoginVM} loginVM 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserJwtControllerApi
     */
    public authenticateUser(loginVM: LoginVM, options?: RawAxiosRequestConfig) {
        return UserJwtControllerApiFp(this.configuration).authenticateUser(loginVM, options).then((request) => request(this.axios, this.basePath));
    }
}



